// Deleting a ticket is permanent: it removes the ticket, its comments, history, e-mails and the stored attachment
// files (DELETE /api/tickets/{id}), and one mis-click on the row's "x" used to be enough. `confirmFn` is
// window.confirm in the pages; `onDelete` runs only after a yes. Returns whether the deletion was started.
export function confirmTicketDeletion(ticket, confirmFn, onDelete) {
  const label = ticket?.ticket_number ? `#${ticket.ticket_number}` : "";
  const title = ticket?.title ? ` "${String(ticket.title).slice(0, 80)}"` : "";
  const ok = confirmFn(`למחוק את קריאה ${label}${title}?\nהפעולה בלתי הפיכה: יימחקו גם ההערות, ההיסטוריה, ההודעות והקבצים המצורפים.`);
  if (!ok) return false;
  onDelete(ticket.id);
  return true;
}
